import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const RnMInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="R & M"
    sectionKey="R & M"
    backRoute="/sections/rnm"
  />
);

export default RnMInternalTransfer;
